export default function Spacer(): React.ReactElement {
  return <div className="w-10 h-10 flex items-center justify-center rounded-full text-sm">...</div>
}
